import React from "react";
import { useCart } from "../context/CartContext";
import { Link } from "react-router-dom";

export default function MiniCartDrawer() {
  const {
    cart,
    total,
    showCart,
    setShowCart,
    increaseQty,
    decreaseQty,
    removeItem,
  } = useCart();

  if (!showCart) return null;

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black/40 backdrop-blur-[2px] z-40 transition-opacity"
        onClick={() => setShowCart(false)}
      />

      {/* Drawer */}
      <div className="fixed top-0 right-0 z-50 h-full w-[85%] sm:w-80 bg-[#FFF7FB] border-l border-white shadow-2xl flex flex-col animate-slideIn">
        {/* HEADER */}
        <div className="px-6 py-5 border-b border-pink-100 flex items-center justify-between bg-gradient-to-r from-[#FFE0EE] to-[#FFF7FB]">
          <div className="space-y-0.5">
            <p className="text-[10px] tracking-[0.3em] uppercase text-[#C06283] font-bold">
              Ane Crochet
            </p>
            <h2 className="text-xl font-serif italic text-[#6B3442]">
              Your Basket 🎀
            </h2>
          </div>
          <button
            onClick={() => setShowCart(false)}
            className="w-10 h-10 flex items-center justify-center rounded-full bg-white text-[#C06283] shadow-sm hover:rotate-90 transition-transform duration-300"
          >
            ✕
          </button>
        </div>

        {/* CART CONTENT */}
        <div className="flex-1 overflow-y-auto px-4 py-6 space-y-4">
          {cart.length === 0 ? (
            <div className="h-full flex flex-col items-center justify-center text-center opacity-50">
              <span className="text-5xl mb-3">🧶</span>
              <p className="text-sm font-medium text-[#6B3442]">Your basket is empty.</p>
            </div>
          ) : (
            cart.map((item) => (
              <div
                key={item.id}
                className="bg-white/80 border border-white rounded-2xl p-4 shadow-sm hover:shadow-md transition-all"
              >
                {/* INFO SECTION (Images Removed) */}
                <div className="flex flex-col justify-between">
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="text-[15px] font-bold text-[#5B2E3C] leading-tight line-clamp-2">
                      {item.name}
                    </h3>
                    <button
                      onClick={() => removeItem(item.id)}
                      className="text-gray-300 hover:text-red-400 transition-colors p-1"
                    >
                      ✕
                    </button>
                  </div>

                  <div className="flex items-center justify-between">
                    <p className="text-sm font-bold text-[#FF6D95]">
                      ₹{item.price.toLocaleString()}
                    </p>

                    {/* QTY CONTROLS */}
                    <div className="flex items-center bg-pink-50/50 rounded-full p-1 border border-pink-100">
                      <button
                        onClick={() => decreaseQty(item.id)}
                        className="w-7 h-7 flex items-center justify-center rounded-full bg-white text-[#C06283] shadow-sm active:scale-90 transition"
                      >
                        −
                      </button>
                      <span className="text-xs font-bold px-3 text-[#6B3442]">
                        {item.qty}
                      </span>
                      <button
                        onClick={() => increaseQty(item.id)}
                        className="w-7 h-7 flex items-center justify-center rounded-full bg-[#6B3442] text-white shadow-sm active:scale-90 transition"
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {/* FOOTER */}
        {cart.length > 0 && (
          <div className="p-6 bg-white border-t border-pink-100 space-y-4 shadow-[0_-10px_20px_rgba(0,0,0,0.02)]">
            <div className="flex items-end justify-between">
              <div>
                <span className="text-[10px] uppercase tracking-widest text-[#B36885] font-bold">
                  Subtotal
                </span>
                <p className="text-2xl font-serif text-[#6B3442]">
                  ₹{total?.toLocaleString()}
                </p>
              </div>
            </div>

            <Link
              to="/cart"
              onClick={() => setShowCart(false)}
              className="block group"
            >
              <div className="w-full py-4 rounded-2xl bg-[#5B2E3C] text-white font-bold text-center shadow-lg group-hover:bg-[#4A2631] transition-all group-active:scale-95">
                Review Basket →
              </div>
            </Link>
          </div>
        )}
      </div>
    </>
  );
}